/* eslint-disable  */
export { BannerCarousel, TestimonialCarousel, VideosSection } from "./Carousel";
export {
  FaqItem,
  HomeDownloadCta,
  HomeHero,
  HomeLearnVideo,
  HomeTestimonial,
  HomeTrust,
  HomeWhy,
} from "./landingPage";
export { LiveGold } from "./LiveGold";
export { PaymentStatus } from "./PaymentStatus";
export { SellPaymentScreen } from "./sell-payment-screen";
export { SellGold } from "./SellGold";
export { SellGoldCheckout } from "./SellGoldCheckout";
export { BuyGoldCheckout } from "./BuyGoldCheckout";
export { BuyPaymentScreen } from "./BuyPaymentScreen";
export {
  ManageSIPMobileItem,
  ManageSIPSummary,
  ManageSIPWebItem,
} from "./ManageSip";
export { Timer } from "./Timer";
export { UserDgWallet } from "./userDgWallet";
export {
  AddBankModal,
  AddCardModal,
  AddUpiModal,
  GiftGoldWelcomeBanner,
  SellKycModal,
} from "./Modals";
